export default __webpack_public_path__ + "static/media/pp-w-1.7e3d861b.svg";